/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import { BasicInformationPageProps } from "./interfaces";
import { basicInformationStyle } from "./styles";
import { useIsMobile } from "../../hooks/useIsMobile";
import { responsiveStyles } from "../../commons/styles";
import { ChangeEvent } from "react";
import { URL } from "../../API/urlEndpoints";
import { OptionField } from "@curefit/pandora";
import * as _ from "lodash";
import { Input, Select } from "antd";
import { RadioButtonSelect } from "../../atoms/RadioButtonSelect";
import {
  genderTypes,
  UploadTypes,
  allowedFileTypes,
  ButtonClickType,
  regexValidation,
  phoneNumberPrefixes,
  inputFieldOptionalLabel,
  OTHER,
  inputFieldMandatoryLabel,
} from "../../constants/commons";
import { ISelectOption } from "@curefit/pandora/dist/components/optionField/optionField.interfaces";
import { UploadComp } from "../../molecules/Upload";
import {
  BasicInfo,
  Gender,
  addressKeyTypes,
  RegisterationFields,
  FieldRenderState,
} from "../../commons/interfaces";
import useSTR from "react-str";
import { deleteData, getData, postData } from "../../utils/fetchers";
import { toast } from "../../utils/toast";
import { InputField } from "../../atoms/InputField";
import { RegistrationFooterButton } from "../../components/RegistrationFooterButton";
import { RegistrationLayout } from "../../components/RegistrationLayout";
import {
  displayConfirmationWhenWindowCloses,
  useDataFromServerToDropdwon,
  getImgURLFromBufferData,
  showDisplayHeadingAndContentFromLoadingStatus,
  getPhoneNumberAndCountryCodeFromCookie,
  getFieldConfigStatus,
  getSpecifObjTypeFromAPI,
  getStateCountryObject,
  isFieldOptional,
  getErrorForField,
} from "../../utils/helpers";
import { ShowMessage } from "../../components/ShowMessage";
import { useUserContext } from "../../hooks/cookieHooks";
import { ErrorComponent } from "../../molecules/ErrorComponent";
export const BasicInformationPage: React.FunctionComponent<BasicInformationPageProps> = (
  props
) => {
  const {
    pageNavigationDetails,
    onNextClick,
    onBackButtonClick,
    onSaveAndExitClick,
    SuccessFullSaveObj,
    isProfilePictureUpdated,
  } = props;
  const { nextScreen } = pageNavigationDetails;
  const { Option } = Select;
  // Calling the SSO Hook to retrieve user information of the logged in user
  const user = useUserContext();
  // State checking whether user can be navigated to the next page or not
  const [
    isNextPageNavAllowed,
    setIsNextPageNavAllowed,
  ] = React.useState<boolean>(false);
  // State for maintaining the city selected
  const [city, setCity] = React.useState<ISelectOption>();
  // State for maintaining the city selected
  const [selectedState, setSelectedState] = React.useState<ISelectOption>();
  // State for maintaining the fullname entered
  const [fullName, setFullName] = React.useState<string>("");
  // State for maintaining the EMAIL entered
  const [email, setEmail] = React.useState<string>();
  // State for maintaining the EMAIL entered
  const [phoneNumber, setPhoneNumber] = React.useState<string>();
  // State for maintaining the country selected
  const [country, setCountry] = React.useState<ISelectOption>();
  // State for maintaining the ZIPCODE selected
  const [zipCode, setZipCode] = React.useState<string>();
  // State for maintaining the selected GENDER
  // TODO: CHANGE the type here whe the commons package is introduced
  const [gender, setGender] = React.useState<string>();
  //State to maintain the uploaded docs/images
  const [successfullUploadedDocs, setSuccessfullUploadedDocs] = React.useState<
    any[]
  >([]);
  // State to maintain the custom entered CITY
  const [customCityEnetered, setCustomCityEnetered] = React.useState<string>();
  // State to maintain whether the PAN card is valid or not
  const [
    isEneteredZIPCodeValid,
    setIsEneteredZIPCodeValid,
  ] = React.useState<boolean>();
  const isMobileView = useIsMobile();

  // [GET] On page load, for fetching the details of Basic Information
  const [
    ,
    {
      result: getBasicInfoPageData,
      revalidator: refetchBasicInfoPageData,
      loading: getBasicInfoLoading,
      error: getBasicInfoError,
    },
  ] = useSTR(getData);

  // [GET] On page load, for fetching country, state and city details for the DROPDOWN component
  const [
    ,
    {
      result: placeInfoData,
      revalidator: refetchPlaceInfoData,
      loading: loadingpPlaceInfoData,
      error: errorPlaceInfoData,
    },
  ] = useSTR(getData);

  // [POST] For Saving data on page.
  const [
    ,
    {
      result: postBasicInfo,
      revalidator: refetchPostBasicInfo,
      loading: postBasicInfoLoading,
      error: postBasicInfoError,
    },
  ] = useSTR(postData);

  // [DELETE] For removing the uploaded Image
  const [
    ,
    {
      result: removeUploadedAsset,
      revalidator: refetchDeleteUploadedAsset,
      loading: loadingRemovedAsset,
      error: errorRemovedAsset,
    },
  ] = useSTR(deleteData);

  // Function which is called whewn the browser closes
  displayConfirmationWhenWindowCloses();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // On page load, calling the GET API
  React.useEffect(() => {
    refetchBasicInfoPageData(
      `${URL.getBasicInformation(_.get(user, "empId"))}`
    );
    refetchPlaceInfoData(`${URL.getLocationDetails}`);
    // send this to the parent component on page load of this screen
    isProfilePictureUpdated && isProfilePictureUpdated(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Hook which retrievs the countryCode And phone number from the userCookie
  const phoneNumberWithCountryCodeObj = React.useMemo(() => {
    return getPhoneNumberAndCountryCodeFromCookie(_.get(user, "phone", ""));
  }, [user]);

  // Callback from the parent Component to SAVE AND QUIT
  React.useEffect(() => {
    onSaveAndExitClick && onPositiveActionClick(ButtonClickType.SAVE_AND_EXIT);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onSaveAndExitClick]);

  const showUserEneteredCityTextBox = React.useMemo(() => {
    return city && city?.label?.includes(OTHER);
  }, [city]);

  React.useEffect(() => {
    if (getBasicInfoPageData) {
      const {
        name,
        phoneNumber,
        email,
        gender,
        address,
        profilePicture,
      } = getBasicInfoPageData;
      if (address) {
        const { state, city, zipcode, country } = address;
        //State
        state && setSelectedState({ label: state, value: state });
        //City
        city && setCity({ label: city, value: city });
        // ZIPcode
        if (zipcode) {
          setZipCode(zipcode);
          setIsEneteredZIPCodeValid(true);
        }
        // Country
        country && setCountry({ label: country, value: country });
      }

      //If Profile pic is present
      // To get the selected Documents from the server on Page load
      let documentsFromServer = getImgURLFromBufferData([profilePicture]);
      documentsFromServer && setSuccessfullUploadedDocs(documentsFromServer);
      // FullName
      name ? setFullName(name) : setFullName(_.get(user, "name", ""));
      // Email
      email ? setEmail(email) : setEmail(_.get(user, "email", ""));
      // Phone Number
      setPhoneNumber(
        _.get(user, "phone", "")
          ? phoneNumberWithCountryCodeObj &&
              phoneNumberWithCountryCodeObj.phoneNumber
          : phoneNumber
      );
      // Gender
      gender && setGender(gender);
    }
  }, [getBasicInfoPageData, phoneNumberWithCountryCodeObj, user]);

  // Showing the success message in a toast component / Fetching data From Server
  React.useEffect(() => {
    if (postBasicInfo) {
      postBasicInfo?.message && toast.success(postBasicInfo.message);
      if (isNextPageNavAllowed) {
        onNextClick(nextScreen);
      } else {
        SuccessFullSaveObj(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postBasicInfo, isNextPageNavAllowed]);

  const onFullNameChange = (fullName: string) => {
    setFullName(fullName);
  };
  const onEmailChange = (email: string) => {
    setEmail(email);
  };
  const onPhoneNumberChange = (phoneNumber: string) => {
    setPhoneNumber(phoneNumber);
  };
  const onZipCodeChange = (zipCode: string) => {
    if (zipCode && zipCode.length > 7) {
      return;
    } else {
      setZipCode(zipCode);
    }
  };

  // For changing the CITY
  const onCityChange = (option: ISelectOption) => {
    setSelectedState({
      label: getStateCountryObject(option.value, placeInfoData).state,
      value: getStateCountryObject(option.value, placeInfoData).state,
    });
    setCountry({
      label: getStateCountryObject(option.value, placeInfoData).country,
      value: getStateCountryObject(option.value, placeInfoData).country,
    });
    setCity(option);
  };

  // For changing the State
  const onStateChange = (option: ISelectOption) => {
    setSelectedState(option);
  };

  // For changing the COUNTRY
  const onCountryChange = (option: ISelectOption) => {
    setCountry(option);
  };

  const onGenderValueChange = (event: ChangeEvent<HTMLInputElement>) => {
    setGender(event.target.value);
  };

  const onPositiveActionClick = (buttonClickType: ButtonClickType) => {
    const basicInfoRequestObject = constructDataForPOSTAPI();

    switch (buttonClickType) {
      case ButtonClickType.NEXT:
        let paramsObj = {
          ...basicInfoRequestObject,
          customHeader: { change_state: true },
        };
        refetchPostBasicInfo(
          `${URL.postBasicInformation(_.get(user, "empId"))}`,
          paramsObj
        );
        setIsNextPageNavAllowed(true);
        break;

      case ButtonClickType.SAVE_AND_EXIT:
        refetchPostBasicInfo(
          `${URL.postBasicInformation(_.get(user, "empId"))}`,
          basicInfoRequestObject
        );
        setIsNextPageNavAllowed(false);
        break;

      default:
        break;
    }
  };

  // Getting hold of the changed CITY name - Manual Entry
  const onCustomCityEneteredChange = (enteredCity: string) => {
    setCustomCityEnetered(enteredCity);
  };

  const constructDataForPOSTAPI = React.useCallback(() => {
    let basicInfoRequestObject: BasicInfo = {
      name: fullName as string,
      gender: gender as Gender,
      email: email as string,
      leadId: _.get(user, "empId"),
      phoneNumber: phoneNumber as string,
      profilePicture: {
        isUploaded: true,
        fileExtension:
          successfullUploadedDocs &&
          Object.keys(successfullUploadedDocs).length > 0 &&
          successfullUploadedDocs[0].fileName,
        filename: UploadTypes.PROFILE_PICTURE,
      },
      address: {
        city:
          city && showUserEneteredCityTextBox
            ? customCityEnetered
            : city?.value,
        state: selectedState && selectedState.value,
        country: country && country.value,
        zipcode: zipCode as string,
      },
    };
    return basicInfoRequestObject;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    city,
    customCityEnetered,
    showUserEneteredCityTextBox,
    country,
    email,
    fullName,
    gender,
    phoneNumber,
    selectedState,
    zipCode,
  ]);

  const isSubmitAllowed = React.useMemo(() => {
    return !(
      fullName &&
      gender &&
      (showUserEneteredCityTextBox
        ? customCityEnetered
        : city && _.keys(city).length > 0) &&
      selectedState &&
      _.keys(selectedState).length > 0 &&
      country &&
      isEneteredZIPCodeValid &&
      zipCode
    );
  }, [
    fullName,
    gender,
    showUserEneteredCityTextBox,
    customCityEnetered,
    isEneteredZIPCodeValid,
    city,
    selectedState,
    country,
    zipCode,
  ]);

  // Function called whenever the user successfully uploads an asset
  const onSuccessfullFileUpload = (onSuccessFileUploadObj: any) => {
    setSuccessfullUploadedDocs([onSuccessFileUploadObj]);
    isProfilePictureUpdated && isProfilePictureUpdated(true);
  };

  // Variable which shows the loading state
  const isScreenLoading = React.useMemo(() => {
    return (
      loadingpPlaceInfoData ||
      postBasicInfoLoading ||
      getBasicInfoLoading ||
      loadingRemovedAsset
    );
  }, [
    loadingpPlaceInfoData,
    postBasicInfoLoading,
    getBasicInfoLoading,
    loadingRemovedAsset,
  ]);

  // Function which is called when the ProfilePicture is removed
  const removeSelectedAsset = (removedAsset: any) => {
    const { filename, id } = removedAsset;
    refetchDeleteUploadedAsset(
      `${URL.removeUploadedAsset(_.get(user, "empId"), id, filename)}`
    );
  };

  // Hook which is called when the ZIP code enetred is right or wrong
  const isZipCodeEneteredValid = (isZipCodeValid: boolean) => {
    setIsEneteredZIPCodeValid(isZipCodeValid);
  };

  // Function which is executed after successfully removing the uploaded Asset
  React.useEffect(() => {
    if (removeUploadedAsset && removeUploadedAsset.success) {
      toast.success(removeUploadedAsset.message);
      isProfilePictureUpdated && isProfilePictureUpdated(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [removeUploadedAsset]);

  React.useEffect(() => {
    placeInfoData?.countries &&
      setCountry({
        label: placeInfoData?.countries[0],
        value: placeInfoData?.countries[0],
      });
  }, [placeInfoData]);

  // Hook which is called whenever there is an error in either GET/POST calls
  const showErrorComponent = React.useMemo(() => {
    return (
      errorRemovedAsset ||
      errorPlaceInfoData ||
      postBasicInfoError ||
      getBasicInfoError
    );
  }, [
    postBasicInfoError,
    errorPlaceInfoData,
    getBasicInfoError,
    errorRemovedAsset,
  ]);

  // For showing/hiding the Full Name field
  const showFullNameField = React.useMemo(() => {
    return (
      getBasicInfoPageData &&
      getBasicInfoPageData.fieldsconfig &&
      _.keys(getBasicInfoPageData.fieldsconfig).length > 0 &&
      getFieldConfigStatus(
        getBasicInfoPageData.fieldsconfig,
        RegisterationFields.FULL_NAME
      )[0] !== FieldRenderState.DISABLED
    );
  }, [getBasicInfoPageData]);

  // For showing the label OPTIONAL for the Full Name field
  const showFullNameLabel = React.useMemo(() => {
    return (
      getBasicInfoPageData &&
      getBasicInfoPageData.fieldsconfig &&
      _.keys(getBasicInfoPageData.fieldsconfig).length > 0 &&
      isFieldOptional(
        getFieldConfigStatus(
          getBasicInfoPageData.fieldsconfig,
          RegisterationFields.FULL_NAME
        )[0]
      ) &&
      inputFieldOptionalLabel
    );
  }, [getBasicInfoPageData]);

  // For showing/hiding the Profile Upload Feature
  const showProfileUploadComponent = React.useMemo(() => {
    return (
      getBasicInfoPageData &&
      getBasicInfoPageData.fieldsconfig &&
      _.keys(getBasicInfoPageData.fieldsconfig).length > 0 &&
      getFieldConfigStatus(
        getBasicInfoPageData.fieldsconfig,
        RegisterationFields.PROFILE_PICTURE_UPLOAD
      )[0] !== FieldRenderState.DISABLED
    );
  }, [getBasicInfoPageData]);

  // For showing the label OPTIONAL for the Profile Upload field
  const showProfileUploadComponentLabel = React.useMemo(() => {
    return (
      getBasicInfoPageData &&
      getBasicInfoPageData.fieldsconfig &&
      _.keys(getBasicInfoPageData.fieldsconfig).length > 0 &&
      isFieldOptional(
        getFieldConfigStatus(
          getBasicInfoPageData.fieldsconfig,
          RegisterationFields.PROFILE_PICTURE_UPLOAD
        )[0]
      ) &&
      inputFieldOptionalLabel
    );
  }, [getBasicInfoPageData]);

  // For showing/hiding the Phone Number field
  const showPhoneNumber = React.useMemo(() => {
    return (
      getBasicInfoPageData &&
      getBasicInfoPageData.fieldsconfig &&
      _.keys(getBasicInfoPageData.fieldsconfig).length > 0 &&
      getFieldConfigStatus(
        getBasicInfoPageData.fieldsconfig,
        RegisterationFields.PHONE_NUMBER
      )[0] !== FieldRenderState.DISABLED
    );
  }, [getBasicInfoPageData]);

  // For showing the label OPTIONAL for the Phone Number field
  const showPhoneNumberLabel = React.useMemo(() => {
    return (
      getBasicInfoPageData &&
      getBasicInfoPageData.fieldsconfig &&
      _.keys(getBasicInfoPageData.fieldsconfig).length > 0 &&
      isFieldOptional(
        getFieldConfigStatus(
          getBasicInfoPageData.fieldsconfig,
          RegisterationFields.PHONE_NUMBER
        )[0]
      ) &&
      inputFieldOptionalLabel
    );
  }, [getBasicInfoPageData]);

  // For showing/hiding the Email field
  const showEmailField = React.useMemo(() => {
    return (
      getBasicInfoPageData &&
      getBasicInfoPageData.fieldsconfig &&
      _.keys(getBasicInfoPageData.fieldsconfig).length > 0 &&
      getFieldConfigStatus(
        getBasicInfoPageData.fieldsconfig,
        RegisterationFields.EMAIL
      )[0] !== FieldRenderState.DISABLED
    );
  }, [getBasicInfoPageData]);

  // For showing the label OPTIONAL for the Email field
  const showEmailLabel = React.useMemo(() => {
    return (
      getBasicInfoPageData &&
      getBasicInfoPageData.fieldsconfig &&
      _.keys(getBasicInfoPageData.fieldsconfig).length > 0 &&
      isFieldOptional(
        getFieldConfigStatus(
          getBasicInfoPageData.fieldsconfig,
          RegisterationFields.EMAIL
        )[0]
      ) &&
      inputFieldOptionalLabel
    );
  }, [getBasicInfoPageData]);

  // For showing/hiding the Gender
  const showGenderField = React.useMemo(() => {
    return (
      getBasicInfoPageData &&
      getBasicInfoPageData.fieldsconfig &&
      _.keys(getBasicInfoPageData.fieldsconfig).length > 0 &&
      getFieldConfigStatus(
        getBasicInfoPageData.fieldsconfig,
        RegisterationFields.GENDER
      )[0] !== FieldRenderState.DISABLED
    );
  }, [getBasicInfoPageData]);

  // For showing the label OPTIONAL for the Gender
  const showGenderLabel = React.useMemo(() => {
    return (
      getBasicInfoPageData &&
      getBasicInfoPageData.fieldsconfig &&
      _.keys(getBasicInfoPageData.fieldsconfig).length > 0 &&
      isFieldOptional(
        getFieldConfigStatus(
          getBasicInfoPageData.fieldsconfig,
          RegisterationFields.GENDER
        )[0]
      ) &&
      inputFieldOptionalLabel
    );
  }, [getBasicInfoPageData]);

  // For showing/hiding the ZIPCODE
  const showZipCodeField = React.useMemo(() => {
    return (
      getBasicInfoPageData &&
      getBasicInfoPageData.fieldsconfig &&
      _.keys(getBasicInfoPageData.fieldsconfig).length > 0 &&
      getFieldConfigStatus(
        getBasicInfoPageData.fieldsconfig,
        RegisterationFields.ZIPCODE
      )[0] !== FieldRenderState.DISABLED
    );
  }, [getBasicInfoPageData]);

  // For showing the label OPTIONAL for ZIPCODE
  const showZipCodeLabel = React.useMemo(() => {
    return (
      getBasicInfoPageData &&
      getBasicInfoPageData.fieldsconfig &&
      _.keys(getBasicInfoPageData.fieldsconfig).length > 0 &&
      isFieldOptional(
        getFieldConfigStatus(
          getBasicInfoPageData.fieldsconfig,
          RegisterationFields.ZIPCODE
        )[0]
      ) &&
      inputFieldOptionalLabel
    );
  }, [getBasicInfoPageData]);

  // For showing/hiding the CITY
  const showCityField = React.useMemo(() => {
    return (
      getBasicInfoPageData &&
      getBasicInfoPageData.fieldsconfig &&
      _.keys(getBasicInfoPageData.fieldsconfig).length > 0 &&
      getFieldConfigStatus(
        getBasicInfoPageData.fieldsconfig,
        RegisterationFields.CITY
      )[0] !== FieldRenderState.DISABLED
    );
  }, [getBasicInfoPageData]);

  // For showing the label OPTIONAL for CITY
  const showCityLabel = React.useMemo(() => {
    return (
      getBasicInfoPageData &&
      getBasicInfoPageData.fieldsconfig &&
      _.keys(getBasicInfoPageData.fieldsconfig).length > 0 &&
      isFieldOptional(
        getFieldConfigStatus(
          getBasicInfoPageData.fieldsconfig,
          RegisterationFields.CITY
        )[0]
      ) &&
      inputFieldOptionalLabel
    );
  }, [getBasicInfoPageData]);

  // For showing/hiding the STATE
  const showStateField = React.useMemo(() => {
    return (
      getBasicInfoPageData &&
      getBasicInfoPageData.fieldsconfig &&
      _.keys(getBasicInfoPageData.fieldsconfig).length > 0 &&
      getFieldConfigStatus(
        getBasicInfoPageData.fieldsconfig,
        RegisterationFields.STATE
      )[0] !== FieldRenderState.DISABLED
    );
  }, [getBasicInfoPageData]);

  // For showing the label OPTIONAL for STATE
  const showStateLabel = React.useMemo(() => {
    return (
      getBasicInfoPageData &&
      getBasicInfoPageData.fieldsconfig &&
      _.keys(getBasicInfoPageData.fieldsconfig).length > 0 &&
      isFieldOptional(
        getFieldConfigStatus(
          getBasicInfoPageData.fieldsconfig,
          RegisterationFields.STATE
        )[0]
      ) &&
      inputFieldOptionalLabel
    );
  }, [getBasicInfoPageData]);

  // For showing/hiding the COUNTRY
  const showCountryField = React.useMemo(() => {
    return (
      getBasicInfoPageData &&
      getBasicInfoPageData.fieldsconfig &&
      _.keys(getBasicInfoPageData.fieldsconfig).length > 0 &&
      getFieldConfigStatus(
        getBasicInfoPageData.fieldsconfig,
        RegisterationFields.COUNTRY
      )[0] !== FieldRenderState.DISABLED
    );
  }, [getBasicInfoPageData]);

  // For showing the label OPTIONAL for STATE
  const showCountryLabel = React.useMemo(() => {
    return (
      getBasicInfoPageData &&
      getBasicInfoPageData.fieldsconfig &&
      _.keys(getBasicInfoPageData.fieldsconfig).length > 0 &&
      isFieldOptional(
        getFieldConfigStatus(
          getBasicInfoPageData.fieldsconfig,
          RegisterationFields.COUNTRY
        )[0]
      ) &&
      inputFieldOptionalLabel
    );
  }, [getBasicInfoPageData]);

  // For showing errors [NAME]
  const nameFieldError = React.useMemo(() => {
    return (
      getBasicInfoPageData &&
      getBasicInfoPageData.errors &&
      getErrorForField(
        RegisterationFields.FULL_NAME,
        getBasicInfoPageData.errors
      )
    );
  }, [getBasicInfoPageData]);

  // For showing errors [PROFILE_PICTURE]
  const profilePictureUploadError = React.useMemo(() => {
    return (
      getBasicInfoPageData &&
      getBasicInfoPageData.errors &&
      getErrorForField(
        RegisterationFields.PROFILE_PICTURE,
        getBasicInfoPageData.errors
      )
    );
  }, [getBasicInfoPageData]);

  // For showing errors [EMAIL]
  const emailError = React.useMemo(() => {
    return (
      getBasicInfoPageData &&
      getBasicInfoPageData.errors &&
      getErrorForField(RegisterationFields.EMAIL, getBasicInfoPageData.errors)
    );
  }, [getBasicInfoPageData]);

  // For showing errors [PHONE_NUMBER]
  const phoneNumberError = React.useMemo(() => {
    return (
      getBasicInfoPageData &&
      getBasicInfoPageData.errors &&
      getErrorForField(
        RegisterationFields.PHONE_NUMBER,
        getBasicInfoPageData.errors
      )
    );
  }, [getBasicInfoPageData]);

  // For showing errors [GENDER]
  const genderError = React.useMemo(() => {
    return (
      getBasicInfoPageData &&
      getBasicInfoPageData.errors &&
      getErrorForField(RegisterationFields.GENDER, getBasicInfoPageData.errors)
    );
  }, [getBasicInfoPageData]);

  // For showing errors [ZIPCODE]
  const zipCodeError = React.useMemo(() => {
    return (
      getBasicInfoPageData &&
      getBasicInfoPageData.errors &&
      getErrorForField(RegisterationFields.ZIPCODE, getBasicInfoPageData.errors)
    );
  }, [getBasicInfoPageData]);

  // For showing errors [CITY]
  const cityError = React.useMemo(() => {
    return (
      getBasicInfoPageData &&
      getBasicInfoPageData.errors &&
      getErrorForField(RegisterationFields.CITY, getBasicInfoPageData.errors)
    );
  }, [getBasicInfoPageData]);

  // For showing errors [STATE]
  const stateError = React.useMemo(() => {
    return (
      getBasicInfoPageData &&
      getBasicInfoPageData.errors &&
      getErrorForField(RegisterationFields.STATE, getBasicInfoPageData.errors)
    );
  }, [getBasicInfoPageData]);

  // For showing errors [COUNTRY]
  const countryError = React.useMemo(() => {
    return (
      getBasicInfoPageData &&
      getBasicInfoPageData.errors &&
      getErrorForField(RegisterationFields.COUNTRY, getBasicInfoPageData.errors)
    );
  }, [getBasicInfoPageData]);

  // Getting hold of City Dropdown values
  const citiesDropdwonValues = useDataFromServerToDropdwon(
    getSpecifObjTypeFromAPI(placeInfoData, addressKeyTypes.CITY) || undefined
  );

  // Getting hold of State Dropdown values
  const stateDropdwonValues = useDataFromServerToDropdwon(
    getSpecifObjTypeFromAPI(placeInfoData, addressKeyTypes.STATE) || undefined
  );

  // Getting hold of Country Dropdown values
  const countryDropdwonValues = useDataFromServerToDropdwon(
    getSpecifObjTypeFromAPI(placeInfoData, addressKeyTypes.COUNTRY) || undefined
  );

  return (
    <span css={[basicInformationStyle, responsiveStyles]}>
      <ShowMessage
        visible={isScreenLoading}
        loading={isScreenLoading}
        heading={
          showDisplayHeadingAndContentFromLoadingStatus({
            preLoginScreen: loadingpPlaceInfoData || getBasicInfoLoading,
            postLoginScreen: postBasicInfoLoading || loadingRemovedAsset,
          })?.loadingHeading
        }
        description={
          showDisplayHeadingAndContentFromLoadingStatus({
            preLoginScreen: loadingpPlaceInfoData || getBasicInfoLoading,
            postLoginScreen: postBasicInfoLoading || loadingRemovedAsset,
          })?.loadingDescription
        }
      />
      <RegistrationLayout>
        <h2>Basic Information</h2>
        {showProfileUploadComponent && (
          <div className="row">
            <div
              className={`col-md-5 col-12 d-flex align-items-center justify-content-start ${
                isMobileView ? " mt-3" : "justify-content-start"
              }`}
            >
              <div className="d-flex flex-column">
                <div className="d-flex">
                  <h6 className="">Profile Picture</h6>
                  <div className="small-text ml-2">
                    {showProfileUploadComponentLabel}
                  </div>
                </div>

                <div className="short-description-style ">
                  White background recommended
                </div>
              </div>
            </div>
            <div className="col-12 col-md-7 d-flex align-items-center justify-content-center">
              <UploadComp
                onSuccess={onSuccessfullFileUpload}
                uploadType={UploadTypes.PROFILE_PICTURE}
                uploadedFiles={successfullUploadedDocs}
                removeSelectedAsset={removeSelectedAsset}
                allowedFilesType={[
                  allowedFileTypes.jpeg,
                  allowedFileTypes.jpg,
                  allowedFileTypes.png,
                ]}
                allowedFileSize={10}
              />
              {profilePictureUploadError && (
                <div className="error-text">{profilePictureUploadError}</div>
              )}
            </div>
          </div>
        )}
        {showFullNameField && (
          <InputField
            placeholder={`Full Name ${
              showFullNameLabel
                ? inputFieldOptionalLabel
                : inputFieldMandatoryLabel
            }`}
            type="text"
            className="my-3"
            initialValue={fullName}
            validationErrMsg={nameFieldError}
            onChange={onFullNameChange}
          />
        )}
        {showEmailField && (
          <InputField
            placeholder={`Email Address ${
              showEmailLabel
                ? inputFieldOptionalLabel
                : inputFieldMandatoryLabel
            }`}
            type="text"
            className="my-3"
            disabled
            initialValue={email}
            validationErrMsg={emailError}
            onChange={onEmailChange}
          />
        )}

        {showPhoneNumber && (
          <div>
            <Input.Group compact>
              <Select
                defaultValue={
                  phoneNumberWithCountryCodeObj &&
                  phoneNumberWithCountryCodeObj.countryCode
                }
              >
                <Option value={phoneNumberPrefixes.india}>
                  {phoneNumberPrefixes.india}
                </Option>
              </Select>
              <InputField
                placeholder={`Phone Number ${
                  showPhoneNumberLabel
                    ? inputFieldOptionalLabel
                    : inputFieldMandatoryLabel
                }`}
                type="number"
                className="my-3"
                disabled={
                  phoneNumberWithCountryCodeObj &&
                  phoneNumberWithCountryCodeObj.phoneNumber
                    ? true
                    : false
                }
                validationErrMsg={phoneNumberError}
                initialValue={phoneNumber && parseInt(phoneNumber)}
                onChange={onPhoneNumberChange}
              />
            </Input.Group>
          </div>
        )}
        {showGenderField && (
          <div className="my-3">
            <div className="d-flex">
              <h6>Gender *</h6>
              <span className="small-text ml-2">
                {showGenderLabel ? showGenderLabel : ""}
              </span>
            </div>
            <RadioButtonSelect
              value={genderTypes}
              defaultValue={gender}
              onValueChange={onGenderValueChange}
            />
            {genderError && <div className="error-text">{genderError}</div>}
          </div>
        )}

        <div className="my-3">
          <h6>Your Location *</h6>
          {showZipCodeField && (
            <InputField
              placeholder={`Zip Code ${
                showZipCodeLabel
                  ? inputFieldOptionalLabel
                  : inputFieldMandatoryLabel
              }`}
              type="number"
              className="my-3"
              initialValue={zipCode}
              onChange={onZipCodeChange}
              validationRegEx={regexValidation.zipCode}
              validationErrMsg={`${
                zipCodeError ? zipCodeError : "Please enter a valid ZIP code"
              }`}
              validate={isZipCodeEneteredValid}
            />
          )}
          <div className="">
            <div className="row p-0">
              {showCityField && (
                <div
                  className={`col-xs-12 my-3 ${
                    showUserEneteredCityTextBox
                      ? "col-md-6 d-flex align-items-center"
                      : "col-md-12"
                  }`}
                >
                  <OptionField
                    options={citiesDropdwonValues}
                    value={city}
                    placeholder={`Enter your city ${
                      showCityLabel
                        ? inputFieldOptionalLabel
                        : inputFieldMandatoryLabel
                    }`}
                    onChange={(option: ISelectOption) => onCityChange(option)}
                  />
                  {cityError && <div className="error-text">{cityError}</div>}
                </div>
              )}
              {showUserEneteredCityTextBox && (
                <div className="col-md-6">
                  <InputField
                    placeholder={`Please enter city name ${
                      showCityLabel
                        ? inputFieldOptionalLabel
                        : inputFieldMandatoryLabel
                    }`}
                    type="text"
                    className="my-3"
                    onChange={onCustomCityEneteredChange}
                  />
                  {cityError && <div className="error-text">{cityError}</div>}
                </div>
              )}
              {showStateField && (
                <div className={`col-lg-12 my-3 ${isMobileView ? "" : ""}`}>
                  <OptionField
                    options={stateDropdwonValues}
                    value={selectedState}
                    placeholder={`Enter your state ${
                      showStateLabel
                        ? inputFieldOptionalLabel
                        : inputFieldMandatoryLabel
                    }`}
                    onChange={(option: ISelectOption) => onStateChange(option)}
                  />
                  {stateError && <div className="error-text">{stateError}</div>}
                </div>
              )}

              {showCountryField && (
                <div
                  className={`${
                    showUserEneteredCityTextBox ? "col-12 my-3" : "my-3 col"
                  }`}
                >
                  <OptionField
                    options={countryDropdwonValues}
                    value={country}
                    placeholder={`Select your country ${
                      showCountryLabel
                        ? inputFieldOptionalLabel
                        : inputFieldMandatoryLabel
                    }`}
                    onChange={(option: ISelectOption) =>
                      onCountryChange(option)
                    }
                  />
                  {countryError && (
                    <div className="error-text">{countryError}</div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
        {showErrorComponent && <ErrorComponent errorObj={showErrorComponent} />}
      </RegistrationLayout>
      <RegistrationFooterButton
        disableNextButton={isSubmitAllowed}
        onPositiveActionClick={onPositiveActionClick}
        onBackButtonClick={onBackButtonClick}
      />
    </span>
  );
};
